module.exports = __webpack_public_path__ + "static/media/yonder.334289b5.png";